import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import { mensajeDeError } from '../api/client';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { Campo, Etiqueta, Entrada, MensajeError } from '../components/ui/Form';

export const Envoltura = styled.div`
  max-width: 420px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.space.xxl} ${({ theme }) => theme.space.md};
`;

export const TituloForm = styled.h1`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.sageDeep};
  text-align: center;
  margin-bottom: ${({ theme }) => theme.space.xs};
`;

export const TextoForm = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.95rem;
  margin-bottom: ${({ theme }) => theme.space.lg};
`;

export const PieForm = styled.p`
  text-align: center;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: ${({ theme }) => theme.space.lg};

  a {
    color: ${({ theme }) => theme.colors.sageDeep};
    font-weight: 600;
    text-decoration: underline;
  }
`;

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const destino = location.state?.desde || '/mi-cuenta/reservas';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setError('');
    setEnviando(true);
    try {
      await login(email, password);
      navigate(destino, { replace: true });
    } catch (err) {
      setError(mensajeDeError(err));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Envoltura>
      <Card>
        <TituloForm>Bienvenida de vuelta</TituloForm>
        <TextoForm>Inicia sesión para reservar y administrar tus clases.</TextoForm>
        {error && <MensajeError role="alert">{error}</MensajeError>}
        <form onSubmit={enviar}>
          <Campo>
            <Etiqueta htmlFor="email">Email</Etiqueta>
            <Entrada
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </Campo>
          <Campo>
            <Etiqueta htmlFor="password">Contraseña</Etiqueta>
            <Entrada
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Campo>
          <Button type="submit" $completo disabled={enviando}>
            {enviando ? 'Entrando…' : 'Iniciar sesión'}
          </Button>
        </form>
        <PieForm>
          ¿Aún no tienes cuenta? <Link to="/registro">Regístrate</Link>
        </PieForm>
      </Card>
    </Envoltura>
  );
}

export default Login;
